import { defaultMeta } from '../routesSetup';

import PatientDetailsView from '../../lib/pages/PatientDetailsView.vue';
import SummaryView from '../../lib/pages/SummaryView.vue';
import SubmittedSuccessfullyView from '../../lib/pages/SubmittedSuccessfullyView.vue';
import { formPatientDetailsYou, formVerificationCode } from '@/data/forms';
import VerificationCodeView from '../../lib/pages/VerificationCodeView.vue';
import PrescriptionListView from '../../lib/pages/PrescriptionListView.vue';

const defaultMetaMedicalRequest = {
  ...defaultMeta,
  pageTitle: 'Prescriptions requests',
  requiresLoadedTenant: true,
};

const repeatPrescriptionRequestChildren = [
  {
    path: 'patient-details',
    name: 'prescriptions-patient-details',
    component: PatientDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formPatientDetailsYou,
    },
  },
  {
    path: 'verification-code',
    name: 'verification-code',
    component: VerificationCodeView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formVerificationCode,
      requiresValidPatient: true,
      redirectIfVerified: true,
    },
  },
  {
    path: 'prescriptions-list',
    name: 'prescriptions-list',
    component: PrescriptionListView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: 'Prescription list',
      requiresValidPatient: true,
      requiresVerifiedPatient: true,
    },
  },
  {
    path: 'summary',
    name: 'prescriptions-summary',
    component: SummaryView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: 'Check your answers',
      requiresValidPatient: true,
      requiresVerifiedPatient: true,
    },
  },
  {
    path: 'submitted-successfully',
    name: 'prescription-submitted-successfully',
    component: SubmittedSuccessfullyView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: null,
      pageTitle: 'Request submitted successfully',
      panelTitle: 'Request sent',
      backButton: false,
    },
  },
];

export default repeatPrescriptionRequestChildren;
